import { useMutation } from '@apollo/client';

import RemoveVerifiableFieldMutation from '@/graphql/contracts/removeVerifiableField.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  RemoveVerifiableField,
  RemoveVerifiableFieldVariables
} from '@/graphql/contracts/_generated_/removeVerifiableField.mutation';
import { notificationService } from '@/services/notification/notification.client';

export type RemoveVerifiableFieldDto = RemoveVerifiableFieldVariables;

export function useRemoveVerifiableField() {

  const [_removeVerifiableField, { loading }] = useMutation<RemoveVerifiableField, RemoveVerifiableFieldVariables>(
    RemoveVerifiableFieldMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const removeVerifiableField = (dto: RemoveVerifiableFieldDto, onSuccess?: () => void) => {
    _removeVerifiableField({
      variables: dto,
      refetchQueries: ['GetVerifiableFields'],
      onCompleted: () => {
        notificationService.open({
          title: 'Verifiable Field',
          text: 'Field successfully removed',
          type: 'success',
        });

        onSuccess?.();
      },
    });
  };

  return {
    removeVerifiableField,
    isLoading: loading,
  } as const;
}
